import { render, staticRenderFns } from "./PreHighLightH5.vue?vue&type=template&id=60dadbb6&scoped=true&"
import script from "./PreHighLightH5.vue?vue&type=script&lang=js&"
export * from "./PreHighLightH5.vue?vue&type=script&lang=js&"
import style0 from "./PreHighLightH5.vue?vue&type=style&index=0&id=60dadbb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dadbb6",
  null
  
)

export default component.exports